import { ReactElement } from "react";
import ParsiMapContent from "./ParsiMapContent";
import { useAppSelector } from "redux/reduxHook";


function Map(): ReactElement {

  return (
    <>
      <div style={{ width: "100%", height: "calc(100vh - 280px)" }} className="border border-grey-300 rounded-lg">
        <ParsiMapContent />
      </div>
    </>
  );
}

export default Map;
